import { EldEdit } from "./EldEdit";
import { EldCreate } from "./EldCreate";
import { EldsList } from "./EldsList";
import RouterOutlinedIcon from "@material-ui/icons/RouterOutlined";

export default {
  icon: RouterOutlinedIcon,
  list: EldsList,
  create: EldCreate,
  edit: EldEdit,
};
